<template>
  <!-- Error 404 -->
  <div class="main-wrapper">
    <div class="container">
      <!-- Header -->
      <div class="authentication-header">
        <div class="container">
          <div class="col-md-12">
            <div class="text-center">
              <img src="@/assets/img/logo.svg" alt="logo" />
            </div>
          </div>
        </div>
      </div>
      <!-- /Header -->

      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <div class="content">
          <div class="maintenance">
            <div class="row">
              <div
                class="col-md-6 d-flex flex-column justify-content-center align-items-center"
              >
                <div class="maintenance-content">
                  <div class="maintenance-title">
                    <h1 class="display-6 mb-1">We’re getting ready to launch</h1>
                    <p class="fs-14">
                      We'll be here soon with our new awesome site, subscribe to be
                      notified.
                    </p>
                  </div>
                  <div class="maintenance-forms d-flex">
                    <div class="mb-3 me-3">
                      <input
                        type="email"
                        class="form-control"
                        placeholder="Enter Your Email Address"
                      />
                    </div>
                    <div>
                      <a href="javascript:void(0);" class="btn btn-dark">Notify Me</a>
                    </div>
                  </div>
                  <div class="comming-soon-pg w-100">
                    <div>
                      <h6 class="mb-3">Coming Soon</h6>
                      <ul
                        class="d-inline-flex align-items-center justify-content-center mb-3"
                      >
                        <li class="me-sm-3 me-2">
                          <div
                            class="d-flex align-items-center justify-content-center flex-column"
                          >
                            <h3 class="days fs-sm-30 fs-30">54</h3>
                            <p class="fs-16">Day</p>
                          </div>
                        </li>
                        <li class="text-gray fw-medium me-sm-3 me-2">:</li>
                        <li class="me-sm-3 me-2">
                          <div
                            class="d-flex align-items-center justify-content-center flex-column"
                          >
                            <h3 class="hours fs-sm-30 fs-30">10</h3>
                            <p class="fs-16">Hrs</p>
                          </div>
                        </li>
                        <li class="text-gray fw-medium me-sm-3 me-2">:</li>
                        <li class="me-sm-3 me-2">
                          <div
                            class="d-flex align-items-center justify-content-center flex-column"
                          >
                            <h3 class="minutes fs-sm-30 fs-30">47</h3>
                            <p class="fs-16">Min</p>
                          </div>
                        </li>
                        <li class="text-gray fw-medium me-sm-3 me-2">:</li>
                        <li>
                          <div
                            class="d-flex align-items-center justify-content-center flex-column"
                          >
                            <h3 class="seconds fs-sm-30 fs-30">00</h3>
                            <p class="fs-16">Sec</p>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="maintenance-img">
                  <img src="@/assets/img/bg/launch.png" alt="img" class="img-fluid" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /Page Wrapper -->

      <!-- Footer -->
      <div class="footer-copyright">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-md-12 d-flex justify-content-center">
              <div class="maintenance-icons d-flex">
                <h6>We'll Be Back Shortly</h6>
                <div class="icons">
                  <a href="javascript:void(0);"
                    ><span><i class="fa-brands fa-facebook"></i></span
                  ></a>
                  <a href="javascript:void(0);"
                    ><span><i class="fa-brands fa-twitter"></i></span
                  ></a>
                  <a href="javascript:void(0);"
                    ><span><i class="fa-brands fa-instagram"></i></span
                  ></a>
                  <a href="javascript:void(0);"
                    ><span><i class="fa-brands fa-linkedin-in"></i></span
                  ></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /Footer -->
    </div>
  </div>
  <!-- /Error 404 -->
</template>
